// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Quill toolbar styles */
.ql-toolbar {
    background-color: white !important; /* Set background to white */
    border: 1px solid #ddd !important;  /* Optional: Add a light border */
  }
  
  .ql-toolbar .ql-picker-label,
  .ql-toolbar .ql-picker-item,
  .ql-toolbar button {
    color: #333 !important;  /* Set text color to dark (black or dark gray) */
  }
  
  .ql-toolbar .ql-active {
    color: #007bff !important; /* Set active item color */
  }
  
  .ql-toolbar button:hover {
    background-color: #f0f0f0 !important; /* Hover effect */
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/custom-quill-toolbar.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,kCAAkC,EAAE,4BAA4B;IAChE,iCAAiC,GAAG,iCAAiC;EACvE;;EAEA;;;IAGE,sBAAsB,GAAG,gDAAgD;EAC3E;;EAEA;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA;IACE,oCAAoC,EAAE,iBAAiB;EACzD","sourcesContent":["/* Custom Quill toolbar styles */\n.ql-toolbar {\n    background-color: white !important; /* Set background to white */\n    border: 1px solid #ddd !important;  /* Optional: Add a light border */\n  }\n  \n  .ql-toolbar .ql-picker-label,\n  .ql-toolbar .ql-picker-item,\n  .ql-toolbar button {\n    color: #333 !important;  /* Set text color to dark (black or dark gray) */\n  }\n  \n  .ql-toolbar .ql-active {\n    color: #007bff !important; /* Set active item color */\n  }\n  \n  .ql-toolbar button:hover {\n    background-color: #f0f0f0 !important; /* Hover effect */\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
